// document.addEventListener('DOMContentLoaded', function() {
//     var discountCodeElement = document.getElementById('discount-code');

//     discountCodeElement.addEventListener('click', function() {
//         var code = 'GLITTERGIFT1500';
//         var tempInput = document.createElement('input');
//         tempInput.style.position = 'absolute';
//         tempInput.style.left = '-9999px';
//         tempInput.value = code;
//         document.body.appendChild(tempInput);
//         tempInput.select();
//         document.execCommand('copy');
//         document.body.removeChild(tempInput);
//         alert('Discount code copied: ' + code);
//     });
// });

document.addEventListener('DOMContentLoaded', function() {
  var discountCodeElement = document.getElementById('discount-code');

  if (!discountCodeElement) return;

  discountCodeElement.addEventListener('click', function() {
    var code = 'GLITTERGIFT1500';

    // Copy to clipboard
    var tempInput = document.createElement('input');
    tempInput.style.position = 'absolute';
    tempInput.style.left = '-9999px';
    tempInput.value = code;
    document.body.appendChild(tempInput);
    tempInput.select();
    document.execCommand('copy');
    document.body.removeChild(tempInput);

    // Remove any existing modal
    var existingModal = document.getElementById('voucher-modal');
    if (existingModal) existingModal.remove();

    // Create modal container
    var overlay = document.createElement('div');
    overlay.id = 'voucher-modal';
    overlay.innerHTML = `
      <div class="product_share-close full" style="
        position:fixed;
        width:100%;
        height:100%;
        top:0;
        left:0;
        background:rgba(0,0,0,0.7);
        z-index:9998;
      "></div>
      <div class="content-product_share" style="
        max-width:350px;
        width:100%;
        background:#fff;
        padding:40px 30px 30px;
        position:fixed;
        top:50%;
        left:50%;
        transform:translate(-50%, -50%);
        border-radius:10px;
        box-shadow:0 10px 40px rgba(0,0,0,0.2);
        z-index:9999;
        text-align:center;
        font-family:inherit;
      ">
        <h3 style="margin-bottom:15px;font-weight:600;color:#333;">Discount Code Copied!</h3>
        <p style="font-size:16px;color:#444;margin-bottom:20px;">Use this code at checkout:</p>
        <div style="font-size:16px;font-weight:500;padding:10px 0;border:1px solid #dedede;border-radius:5px;margin-bottom:20px;">${code}</div>
        <button id="voucher-ok-btn" style="
          background:#222;
          color:#fff;
          border:none;
          padding:10px 30px;
          height:40px;
          text-transform:uppercase;
          font-size:12px;
          letter-spacing:1px;
          cursor:pointer;
          border-radius:5px;
        ">OK</button>
      </div>
    `;

    document.body.appendChild(overlay);
    document.body.style.overflow = 'hidden';

    // Close modal function
    const closeModal = () => {
      overlay.remove();
      document.body.style.overflow = '';
    };

    // Close on overlay click or OK button
    overlay.querySelector('.product_share-close.full').addEventListener('click', closeModal);
    overlay.querySelector('#voucher-ok-btn').addEventListener('click', closeModal);
  });
});
